import React from "react";
import { Instagram, Facebook, Mail, Phone } from "lucide-react";

export default function Footer({ brand, contact, footer, nav }) {
  const f = footer || {};
  const bgColor = f.bgColor || "#1f3a2c";
  const quickLinks = nav || [];

  return (
    <footer style={{ backgroundColor: bgColor }} className="text-white pt-14 pb-6">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src={brand?.logo}
              alt="logo"
              className="w-12 h-12 rounded-full object-cover ring-1 ring-white/20"
            />
            <span className="font-serif-display text-2xl">{brand?.name}</span>
          </div>
          <p className="text-sm text-white/65 leading-relaxed max-w-xs">
            {f.tagline ||
              "A premium South Indian cafe experience rooted in tradition and crafted with love."}
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h5 className="font-serif-display text-xl mb-4">Quick Links</h5>
          <ul className="space-y-2">
            {quickLinks.map((n) => (
              <li key={n.label}>
                <a
                  href={n.href}
                  className="text-sm text-white/70 hover:text-[#c4a574] transition-colors"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h5 className="font-serif-display text-xl mb-4">Get in Touch</h5>
          <ul className="space-y-3 text-sm text-white/75 mb-5">
            <li className="flex items-center gap-2">
              <Phone size={14} className="text-[#c4a574]" /> {contact?.phone}
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} className="text-[#c4a574]" /> {contact?.email}
            </li>
          </ul>
          <div className="flex items-center gap-3">
            {f.instagramUrl && (
              <a
                href={f.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/8 border border-white/15 flex items-center justify-center hover:bg-[#c4a574] hover:border-[#c4a574] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
            )}
            {f.facebookUrl && (
              <a
                href={f.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/8 border border-white/15 flex items-center justify-center hover:bg-[#c4a574] hover:border-[#c4a574] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={16} />
              </a>
            )}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
        <span>{f.copyright}</span>
        <a href="/admin" className="hover:text-white transition-colors">
          Admin
        </a>
      </div>
    </footer>
  );
}
